import React, { useMemo } from "react";

import { LocalisedText } from "../../i18n";

import OrderStatusHistoryTimeline from "./OrderStatusHistoryTimeline";
import OrderShipmentInfoDetails from "./OrderShipmentInfoDetails";

import {
  OrderStatus,
  ReducedOrderStatusHistory,
} from "../../generated/graphql";

import styles from "./style.module.scss";

export interface OrderShipmentInfo {
  deliverBy: string | null;
  trackingNumber: string | null;
}

interface OrderStatusWidgetProps {
  statusHistories: ReducedOrderStatusHistory[];
  currentStatus: OrderStatus;
  shipmentInfo: OrderShipmentInfo;
}

const OrderStatusWidget: React.FC<OrderStatusWidgetProps> = props => {
  const { statusHistories, currentStatus, shipmentInfo } = props;

  const shouldShowShippingInfo = useMemo(() => {
    return currentStatus === OrderStatus.Shipped;
  }, [currentStatus]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <LocalisedText id="view.orderStatusWidget.header.title" />
      </div>
      <div className={styles.content}>
        <div className={styles.timeline}>
          <OrderStatusHistoryTimeline statusHistories={statusHistories} />
        </div>
        {shouldShowShippingInfo && (
          <div className={styles.shipmentInfo}>
            <OrderShipmentInfoDetails currentShipmentInfo={shipmentInfo} />
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderStatusWidget;
